export default {
    client : [],
    clear : function(signal){
        if(!this.client[signal]){
            delete this.client[signal];
        }
    },
    on : function(signal,callback){
        if(!this.client[signal]){
            this.client[signal] = {
                func : [],
                isonce : false
            };
        }else if(this.client[signal].isonce == false){
            this.client[signal].func.push(callback);
        }else{
            console.warn(signal + " : 已经被声明为监听一次，此次监听无效");
        }
    },
    once : function(signal,callback){
        if(!this.client[signal]){
            this.client[signal] = {
                func : [],
                isonce : true
            };
        }else{
            this.client[signal] = {
                func : [],
                isonce : true
            };
            console.warn(signal + " : 已声明为监听一次，其他已有监听将不被调用");
        }
        this.client[signal].func.push(callback);
    },
    emit : function(){
        var key = Array.prototype.shift.call(arguments); //取出消息类型
        var fns = this.client[key];
        if(!fns || fns.length ===0 ){ //如果没有订阅改消息，则返回
            return false;
        }
        for (var i = 0,fn;fn=fns.func[i++];){
            fn.apply(this,arguments); //arguments  是发布消息时带上的参数
            if(fns.isonce){
                delete this.client[key];
                break;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/script/js/privateSignal.js